/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */

/**
 * Allowed content verification status type values.
 */
export type ContentVerificationStatusType =
  (typeof ContentVerificationStatusType)[keyof typeof ContentVerificationStatusType];

export const ContentVerificationStatusType = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  RE_REVIEW_REQUESTED: 'RE_REVIEW_REQUESTED',
} as const;
